import { getEnvConfig } from "@/utils/getEnv";

export enum WebsiteUrlEn {
  Discord = "https://discord.com/invite/roolna",
  Facebook = "https://www.facebook.com/roo.gravity",
  Twitter = "https://twitter.com/Ragnarok_NA",
  Youtube = "https://www.youtube.com/channel/UCJi72qp6wBRnre_pspNdSWA",
  Tiktok = "https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1",
  Instagram = "https://www.instagram.com/ragnarokorigin_en",
  Kwai = "https://k.kwai.com/u/@roobr/CebkjM6n",
  Line = "https://line.me/ti/g2/qaHxThQHYWJIFkcO3j6BmcL3eqI1bmjtquvQDw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default",
}

export enum WebsiteUrlHmt_zhTW {
  Discord = "https://discord.com/invite/akcVsmUhBk",
  Facebook = "https://www.facebook.com/roo.gravity",
  Line = "https://line.me/ti/g2/qaHxThQHYWJIFkcO3j6BmcL3eqI1bmjtquvQDw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default",
  Bahamut = "https://m.gamer.com.tw/forum/B.php?bsn=37657&page=&subbsn=",
}
export enum WebsiteUrlEs {
  Discord = "https://discord.com/invite/roolna",
  Facebook = "https://www.facebook.com/RagnarokOriginROOSP",
  Twitter = "https://twitter.com/RagnaOrigin_ES",
  Youtube = "https://www.youtube.com/@RagnarokOriginLATAM",
  Tiktok = "https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1",
  Instagram = "https://www.instagram.com/latamragnarokorigin",
  Kwai = "https://k.kwai.com/u/@roobr/CebkjM6n",
}

/* 【葡萄牙】 跳转链接 */
export enum WebsiteUrlPt {
  Discord = "https://discord.com/invite/roolna",
  Facebook = "https://www.facebook.com/RagnarokOriginROOPT",
  Twitter = "https://twitter.com/RagnaOrigin_BR",
  Youtube = "https://www.youtube.com/@RagnarokOriginBR",
  Tiktok = "https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1",
  Instagram = "https://www.instagram.com/ragnarokorigin_br",
  Kwai = "https://k.kwai.com/u/@roobr/CebkjM6n",
}

/* 【英语】 跳转链接 */
export enum WebsiteUrlSea {
  Discord = "https://discord.gg/rooglobal",
  Facebook = "https://www.facebook.com/rooglobal",
  Twitter = "https://twitter.com/GlobalRagnarok",
  Youtube = "https://www.youtube.com/channel/UC63jl9OHPZgb5yBR6h5IncQ",
  Tiktok = "https://www.tiktok.com/@ragnarok_origin_global",
}

/* 【印尼】 跳转链接 */
export enum WebsiteUrlId {
  Discord = "https://discord.gg/rooglobal",
  Facebook = "https://www.facebook.com/RagnarokOriginIndonesia",
  Twitter = "https://twitter.com/GlobalRagnarok",
  Youtube = "https://www.youtube.com/@RagnarokOriginSEA",
  Tiktok = "https://www.tiktok.com/@ragnarok_origin_id",
}

/* 【泰国】 跳转链接 */
export enum WebsiteUrlTh {
  Discord = "https://discord.gg/rooglobal",
  Facebook = "https://www.facebook.com/RagnarokOriginThailandOfficial",
  Twitter = "https://twitter.com/GlobalRagnarok",
  Youtube = "https://www.youtube.com/@RagnarokOriginTH",
  Tiktok = "https://www.tiktok.com/@ragnarok_origin_th",
}

export enum WebsiteUrlTc {
  Facebook = "https://www.facebook.com/roo.gravity",
  Line = "https://line.me/ti/g2/qaHxThQHYWJIFkcO3j6BmcL3eqI1bmjtquvQDw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default",
  Youtube = "https://www.youtube.com/@Ragnarok_Origin",
  Discord = "https://discord.com/invite/akcVsmUhBk",
  Bahamut = "https://m.gamer.com.tw/forum/B.php?bsn=37657&page=&subbsn=",
}

export enum ChannelUrlSea {
  Ios = "https://apps.apple.com/us/app/ragnarok-origin-global/id1661507061",
  GooglePlay = "https://play.google.com/store/apps/details?id=com.gravity.roo.sea",
  Windows = "https://ro-cdn-sea-cf.roglobal.com/package/pc_download.html",
  Apk = "https://ro-cdn-sea-cf.roglobal.com/package/apk_download.html",
  Pay = "/shopStore/selectOrder",
  PayMobile = "/m/shopStore/selectOrder",
  Gleam = "https://gleam.io/7BrwV/roo-preregistration-event-1-million-ingame-items-huawei-phones-await",
  Huawei = "https://appgallery.cloud.huawei.com/ag/n/orderappdetail/C107769719",
  Oppo = "oaps://mk/dt?id=30968199",
  Razer = "https://gold.razer.com/gold/catalog/ragnarok-origin",
}

export enum ChannelUrlHmt {
  Ios = "https://apps.apple.com/tw/app/id1618358912",
  GooglePlay = "https://play.google.com/store/apps/details?id=com.gravity.roo.tw",
  Apk = "https://cdn-tc-hmt-tx.huanle.com/ro-official-hmt/web/apk_download.html",
  MyCardPay = "https://www.gnjoy.hk/billing",
  Windows = "https://roo.gnjoy.hk/static/download/roo_launcher.exe",
}

export enum ChannelUrlLna {
  Ios = "https://apps.apple.com/us/app/ragnarok-origin-roo/id6459411007",
  GooglePlay = "https://play.google.com/store/apps/details?id=com.gravity.roo.lna",
  Windows = "https://ro-cdn-lna-cf.roglobal.com/package/download.html",
  Apk = "https://ro-cdn-lna-cf.roglobal.com/package/download.html?type=apk",
  Pay = "/shopStore/selectOrder",
  PayMobile = "/m/shopStore/selectOrder",
  Gleam = "https://gleam.io/7BrwV/roo-preregistration-event-1-million-ingame-items-huawei-phones-await",
  Huawei = "https://appgallery.huawei.com/app/C109740441",
  Oppo = "oaps://mk/dt?id=30968199",
  Razer = "https://gold.razer.com/gold/catalog/ragnarok-origin",
}

export const DownloadUrlMap = {
  hmt: ChannelUrlHmt,
  lna: ChannelUrlLna,
  sea: ChannelUrlSea,
};

export const WebsiteUrlMap = {
  cn: WebsiteUrlEn,
  en: WebsiteUrlEn,
  es: WebsiteUrlEs,
  id: WebsiteUrlId,
  pt: WebsiteUrlPt,
  tc: WebsiteUrlTc,
  th: WebsiteUrlTh,
};

enum WebsiteUrlSeaEn {
  Discord = "https://discord.gg/rooglobal",
  Facebook = "https://www.facebook.com/rooglobal/",
  Twitter = "https://twitter.com/GlobalRagnarok",
  Youtube = "https://www.youtube.com/@RagnarokOriginGlobal",
  Tiktok = "https://www.tiktok.com/@ragnarok_origin_global",
}

enum WebsiteUrlSeaId {
  Discord = "https://discord.gg/rooglobal",
  Facebook = "https://www.facebook.com/RagnarokOriginIndonesia",
  Twitter = "https://twitter.com/GlobalRagnarok",
  Youtube = "https://www.youtube.com/@RagnarokOriginIndonesia",
  Tiktok = "https://www.tiktok.com/@ragnarok_origin_id",
}

enum WebsiteUrlSeaTh {
  Discord = "https://discord.gg/rooglobal",
  Facebook = "https://www.facebook.com/RagnarokOriginThailandOfficial/",
  Twitter = "https://twitter.com/GlobalRagnarok",
  Youtube = "https://www.youtube.com/@RagnarokOriginTH",
  Tiktok = "https://www.tiktok.com/@ragnarok_origin_th",
}

enum WebsiteUrlLnaEn {
  Discord = "https://discord.gg/roolna",
  Facebook = "https://www.facebook.com/OFFICIALRagnarokOriginROO",
  Twitter = "https://x.com/Ragnarok_NA",
  Youtube = "https://www.youtube.com/@RagnarokOrigin_NA",
  Tiktok = "https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1",
}

enum WebsiteUrlLnaEs {
  Discord = "https://discord.gg/roolna",
  Facebook = "https://www.facebook.com/RagnarokOriginROOSP",
  Youtube = "https://www.youtube.com/@RagnarokOriginLATAM",
  Tiktok = "https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1",
  Twitter = "https://x.com/RagnaOrigin_ES",
}
enum WebsiteUrlLnaPt {
  Discord = "https://discord.gg/roolna",
  Facebook = "https://www.facebook.com/RagnarokOriginROOPT",
  Youtube = "https://www.youtube.com/@RagnarokOriginBR",
  Tiktok = "https://www.tiktok.com/@ragnark.origin.of?_t=8iil1OWuPRN&_r=1",
  Twitter = "https://x.com/RagnaOrigin_BR",
}

export const getWebsiteUrl = () => {
  const platform = getEnvConfig().env;
  console.log({ platform });
  switch (platform) {
    case "lna":
      return {
        en: WebsiteUrlLnaEn,
        es: WebsiteUrlLnaEs,
        pt: WebsiteUrlLnaPt,
      };
    case "hmt":
      return {
        "zh-TW": WebsiteUrlHmt_zhTW,
      };
    case "sea":
      return {
        en: WebsiteUrlSeaEn,
        hi: WebsiteUrlSeaId,
        th: WebsiteUrlSeaTh,
      };
    default:
      return {
        "zh-TW": WebsiteUrlEn,
        en: WebsiteUrlEn,
        es: WebsiteUrlEs,
        hi: WebsiteUrlId,
        pt: WebsiteUrlPt,
        tc: WebsiteUrlTc,
        th: WebsiteUrlTh,
      };
  }
};
